import { Helpers } from '@front/utils';
import { createComponent } from '@front/utils/alpine';
const Partners = createComponent(() => ({
    init() {
        if (Helpers.Screen.isWiderThanBreakpoint('md')) {
            const partnerItems = document.querySelectorAll('.js-partner');
            for (let index = 0; index < 2; index++) {
                partnerItems.forEach((item) => {
                    const clone = item.cloneNode(true);
                    clone.classList.add('hidden', 'md:block');
                    this.$refs.wrapper.appendChild(clone);
                });
            }
        }
    },
}));
export { Partners };
